import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Avoid throwing during module import to prevent Vite 500s when env vars are not loaded yet.
// We lazily create the client only if both env vars exist.
let client: any = null;
if (typeof supabaseUrl === 'string' && supabaseUrl && typeof supabaseAnonKey === 'string' && supabaseAnonKey) {
  client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });
} else {
  console.warn('Supabase env not set: VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing');
}

export const supabase = client as any;
